export const resolveAttachFilesTooltip = (param)=>{
    let { isUploading, isDisabled, texts } = param;
    if (isUploading) return texts.uploading;
    if (isDisabled) return texts.exceededLimit;
    return undefined;
};
